import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const i18nInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  
  const lang = translate.currentLang() || 'es';

  const clonedRequest = req.clone({
    setHeaders: {
      'Accept-Language': lang
    }
  });

  return next(clonedRequest);
};